import { createI18n } from "vue-i18n";
import enUS from './locales/en-US.json';
import thTH from './locales/th-TH.json';
import loLA from './locales/lo-LA.json';

// const getLocalesData = () => {
//     const files = [{ en: enUS }, { th: thTH }];
//     const localeData = {
//         datetimeFormats: {},
//         numberFormats: {},
//         messages: {}
//     }
//     const keys = Object.keys(files) //files.keys();
//     files.forEach((key) => {
//         console.log(key)
//         // extract name without extension
//         const matched = key.match(/([A-Za-z0-9-_]+)\./i)
//         if (matched && matched.length > 1) {
//             const localeId = matched[1]
//             // from each file, set the related messages property
//             localeData.datetimeFormats[localeId] = files(key).datetimeFormats
//             localeData.numberFormats[localeId] = files(key).numberFormats
//             localeData.messages[localeId] = files(key).messages
//         }
//     })
//     return localeData
// }

// const data = getLocalesData()
// console.log(data)

// export default createI18n({
//     locale: 'th-TH',
//     fallbackLocale: 'th-TH',
//     messages: data.messages,
//     datetimeFormats: data.datetimeFormats,
//     numberFormats: data.numberFormats
// })


function loadLocaleMessages() {
    const locales = [{ en: enUS }, { th: thTH }, { lo: loLA }];
    const messages = {};
    const numberFormats = {};
    const datetimeFormats = {};
    locales.forEach((lang) => {
        const key = Object.keys(lang);
        messages[key] = lang[key].messages;
        numberFormats[key] = lang[key].numberFormats;
        datetimeFormats[key] = lang[key].datetimeFormats;
    });
    return { messages, numberFormats, datetimeFormats };
}
const { messages, numberFormats, datetimeFormats } = loadLocaleMessages()
export default createI18n({
    locale: "th",
    fallbackLocale: "th",
    legacy: false,
    messages,
    numberFormats,
    datetimeFormats,
});